import React from 'react';
import { Button, BackButton, ResultValue, PrintButton } from '../Components/Simple';
import {
  BasicInformation, ClaimDetails, FactorAndAdjustments, OperatingAmounts, CaptialAmounts,
  OtherPPSAmounts, NonPPSPricing, PricingErrors
} from '../Components/Combined/Results';
import { IPPS } from '../Constants/modelTypes';
import { formatStringAsCurrency, formatDateString } from '../Utils/stringUtils';
import { API_DATE_STRING_FORMAT, DATE_STRING_FORMAT } from '../Constants/stringFormats.js';
import { useNavigate, useLocation } from 'react-router-dom';
import DRGResults from '../Components/Results/DRGResults';
import Protect from '../Components/Combined/Protect';
import { HIDE } from '../Constants/protectionBehaviors';
import { EOB_VIEW } from '../Constants/moduleNames';
import { enableEOB } from '../Utils/features';

export default function IPAcuteResult() {
  const location = useLocation();
  const navigate = useNavigate();
  const { result, fiscalYear, totalBilledOrgAcquistion, drgServiceMode, pricingFYQuarter } = location.state;

  const processedDate = new Date();

  const handleNavigateToEOBGenerator = () => {
    const fromDate = formatDateString(result.fromDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)
    const toDate = fromDate && formatDateString(result.toDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)
    navigate('/EOB', {
      state: {
        processedDate,
        pricerType: IPPS,
        lines: [{
          dateOfService: toDate && `${fromDate} - ${toDate}`,
          serviceCode: "",
          serviceDescription: "IP Hospital Services",
          qty: "",
          billedAmount: parseFloat(result.totalBilled) || 0,
          allowedAmount: parseFloat(result.medicareAllowed) || 0,
          initialMaxShiftAmount: 0
        }]
      }
    });
  };

  return (<div className="py-2">
    <div className="row g-0 sticky top border-bottom">
      <div className="row justify-content-between g-0">
        <div className="col-auto">
          <PrintButton />
        </div>
        <div className="col-auto">
          <Protect module={EOB_VIEW} behavior={HIDE} >
            {enableEOB && <Button className="btn btn-success" onClick={handleNavigateToEOBGenerator} text="Generate EOB" />}
          </Protect>
        </div>
        <div className="col-auto">
          <BackButton />
        </div>
      </div>
      <div className="row my-2 g-0">
        <div className="col">
          <h2>IP Acute Pricer - Pricing Outputs</h2>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <ResultValue label="Medicare Allowed Amount" value={formatStringAsCurrency(result.medicareAllowed)} labelClassName="fs-4 fw-500" valueClassName="fs-4 fw-500" />
      </div>
    </div>
    <PricingErrors result={result} totalMedicareAllowed={result.medicareAllowed} />
    <div className="row my-2">
      <div className="col-md-6">
        <BasicInformation fiscalYear={fiscalYear} result={result} model={IPPS} dataFiscalQuarter={pricingFYQuarter} processedDate={processedDate} />
      </div>
    </div>
    <div className="row my-2">
      <div className="col-md">
        <ClaimDetails result={result} model={IPPS} totalBilledOrgAcquistion={totalBilledOrgAcquistion} />
      </div>
      <div className="col-md">
        <FactorAndAdjustments result={result} model={IPPS} />
      </div>
    </div>
    <h3>PPS Pricing</h3>
    <div className="row my-2">
      <div className="col-md">
        <OperatingAmounts result={result} />
      </div>
      <div className="col-md">
        <CaptialAmounts result={result} />
      </div>
    </div>
    <div className="row my-2">
      <div className="col">
        <OtherPPSAmounts result={result} />
      </div>
    </div>
    <h3>Non-PPS Pricing</h3>
    <div className="row my-2">
      <div className="col-md-6">
        <NonPPSPricing result={result} />
      </div>
    </div>
    <DRGResults result={result} serviceMode={drgServiceMode} />
  </div>
  );
}
